import { CartAddEvent } from '@theme/events';

const addUrl = () => window.Theme?.routes?.cart_add_url || '/cart/add.js';

function cartSectionIds() {
  const ids = new Set();
  document.querySelectorAll('cart-items-component').forEach((el) => {
    if (el instanceof HTMLElement && el.dataset.sectionId) ids.add(el.dataset.sectionId);
  });
  return [...ids];
}

async function readItemCount(sections, sectionIds) {
  for (const id of sectionIds) {
    const html = sections?.[id];
    if (!html) continue;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const count = doc.querySelector('[ref="cartItemCount"]')?.textContent;
    if (count) return parseInt(count, 10);
  }
  const cart = await fetch(`${window.Theme?.routes?.cart_url || '/cart'}.js`).then((r) => r.json());
  return cart.item_count;
}

async function onUpsellSubmit(event) {
  const form = event.target;
  if (!(form instanceof HTMLFormElement) || !form.matches('[data-bonded-upsell]')) return;
  event.preventDefault();

  const button = form.querySelector('button[type="submit"]');
  const error = form.querySelector('.bonded-upsell__error');
  const id = Number(new FormData(form).get('id'));
  if (!id || !(button instanceof HTMLButtonElement) || button.disabled) return;

  button.disabled = true;
  form.classList.add('is-loading');
  if (error) {
    error.hidden = true;
    error.textContent = '';
  }

  const sectionIds = cartSectionIds();

  try {
    const response = await fetch(addUrl(), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id, quantity: 1 }],
        sections: sectionIds.join(','),
        sections_url: window.location.pathname,
      }),
    });
    const data = await response.json();
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Toevoegen is niet gelukt. Probeer het opnieuw.');
    }

    const itemCount = await readItemCount(data.sections, sectionIds);

    document.dispatchEvent(
      new CartAddEvent({}, `bonded-upsell-${id}`, {
        source: 'bonded-cart-upsell',
        itemCount,
        variantId: String(id),
        sections: data.sections,
      })
    );
  } catch (err) {
    if (error) {
      error.textContent = err instanceof Error ? err.message : 'Toevoegen is niet gelukt.';
      error.hidden = false;
    }
    button.disabled = false;
    form.classList.remove('is-loading');
  }
}

if (!window.bondedCartUpsellReady) {
  window.bondedCartUpsellReady = true;
  document.addEventListener('submit', onUpsellSubmit);
}
